<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'
import { gmapApi } from 'vue2-google-maps'
import { required, maxLength } from 'vuelidate/lib/validators'
import moment from 'moment'
import { mapGetters } from 'vuex'

import {
  CREATE_ADDRESS,
  GET_PROVINCES,
  GET_CITIES,
  GET_DISTRICTS,
  GET_REGION_BY_LAT_LNG,
  GET_DETAIL_ADDRESS,
  UPDATE_ADDRESS,
  GET_ADDRESS,
} from '@/services/api/master/address'
import { GET_ADDRESS_CATEGORIES } from '@/services/api/setting/general/address'

import { GetAddressData } from '@/services/api/map'
import { getAddress, getGeolocation } from '@/services/api/geolocation'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Alamat Pelanggan',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    McButton,
  },
  mixins: [Helper],
  apollo: {
    geofence: {
      query: GET_DETAIL_ADDRESS,
      variables() {
        return {
          filter: {
            geofenceId: parseInt(this.id),
          },
        }
      },
      // Disable the query
      skip() {
        return this.$route.params.id === undefined
      },
      result({ data, loading }) {
        if (!loading) {
          this.geofence = {
            geofence: data.geofence.geofence,
          }
          setTimeout(() => {
            this.initEditPage()
          }, 800)
        }
      },
    },
    geofences: {
      query: GET_ADDRESS,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          const geofences = data.geofences.geofences.data
          this.isHQ = geofences.some((geofence) => geofence.category === 'Kantor Pusat')
        }
      },
    },
    addressCategories: {
      query: GET_ADDRESS_CATEGORIES,
      result({ data, loading }) {
        if (!loading) {
          this.categoryOptions = data.addressCategories.addressCategories.map((item) => item.text)
        }
      },
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'check',
        },
        {
          key: 'type',
          label: 'Type',
          tdClass: 'typeWidth',
        },
        {
          key: 'number',
          label: 'Number',
        },
        {
          key: 'expired',
          label: 'Expired',
        },
        {
          key: 'status',
          label: 'Status',
        },
      ],
      customer: { name: null, uuid: null },
      tData: [],
      addressCategories: {
        addressCategories: [],
      },
      categoryOptions: [],
      isEdit: false,

      form: {
        customerId: null,
        customerName: null,
        sector: null,
        location_name: null,
        address: null,
        province: null,
        city: null,
        district: null,
        postal_code: null,
        contact_person: null,
        phone_no: null,
        radius: 100,
        latitude: '',
        longitude: '',
        serviceStart: null,
        serviceEnd: null,
        circle_data: [],
        poly_data: [],
        address_detail: '',
        latLang: '',
        is_billingAddr: false,
        is_depot: false,
        service_location: null,
        operationalDay: ['0'],
        serviceDuration: null,
        reference_id: null,
      },
      geofence: {
        geofence: {},
      },
      loading: false,
      poly_error: false,
      circle_error: false,
      searchLocation: null,
      map_radio: 'circle',
      map: null,
      circle: null,
      polygon: null,
      places: [],
      id: this.$route.params.id || 0,
      invalid: false,
      duplicateLocation: false,
      duplicateReferenceId: false,
      formErrors: {},
      isInitSearchRegion: false,
      regionOptions: {
        provinces: [],
        cities: [],
        districts: [],
      },
      selectedRegion: {
        province: null,
        city: null,
        district: null,
      },
      operationalDayOptions: [
        { value: '0', label: 'global.filter.all' },
        { value: '1', label: 'global.days.monday' },
        { value: '2', label: 'global.days.tuesday' },
        { value: '3', label: 'global.days.wednesday' },
        { value: '4', label: 'global.days.thursday' },
        { value: '5', label: 'global.days.friday' },
        { value: '6', label: 'global.days.saturday' },
        { value: '7', label: 'global.days.sunday' },
      ],
      optionItems: [
        {
          key: 'hours',
          items: Array.from({ length: 24 }, (_, i) => i),
        },
        {
          key: 'minutes',
          items: Array.from({ length: 60 }, (_, i) => i),
        },
      ],
    }
  },
  validations: {
    form: {
      sector: { required },
      location_name: { required, maxLength: maxLength(255) },
      address: { required },
      province: { required },
      city: { required },
      latLang: { required },
      phone_no: { maxLength: maxLength(15) },
      contact_person: { maxLength: maxLength(60) },
    },
  },
  computed: {
    google: gmapApi,

    ...mapGetters({
      getFeatureFlagData: 'identity/getFeatureFlagData',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
      hasAccessAll: 'identity/hasAccessAll',
    }),

    title() {
      return this.$route.params.id === undefined
        ? this.$t('master.form.customer.newAddress')
        : this.$t('master.form.customer.changeAddress')
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: 'Pelanggan',
          to: `/master/customer`,
        },
        {
          text: 'Detail Pelanggan',
          to: `/master/customer/update/${this.$route.params.uuid}`,
        },
        {
          text:
            this.$route.params.id === undefined
              ? this.$t('master.form.customer.newAddress')
              : this.form.location_name,
          active: true,
        },
      ]
    },
    provinces() {
      const provinces = this.regionOptions.provinces.map((item) => item.name)
      if (this.form.province && !provinces.includes(this.form.province)) {
        provinces.unshift(this.form.province)
      }
      return [...new Set(provinces)].sort()
    },
    cities() {
      const cities = this.regionOptions.cities.map((item) => item.name)
      if (this.form.city && !cities.includes(this.form.city)) {
        cities.unshift(this.form.city)
      }
      return cities
    },
    districts() {
      const districts = this.regionOptions.districts.map((item) => item.name)
      if (this.form.district && !districts.includes(this.form.district)) {
        districts.unshift(this.form.district)
      }
      return [...new Set(districts)].sort()
    },
    oldData() {
      if (this.geofence?.geofence !== undefined) {
        let old = { ...this.geofence.geofence }
        if (this.map_radio == 'circle') {
          var latLang = []
          if (this.geofence.geofence.circData !== null) {
            var circData = this.geofence.geofence.circData.replace('<', '').replace('>', '')
            var circleArray = circData.split('),')
            old.radius = circleArray[1]
            latLang = circleArray[0].replace('(', '').split(',')
          }
          old.circle_data = latLang
          old.poly_data = []
        } else {
          var newPoly = []
          if (this.geofence.geofence.polyData !== null) {
            var polyData = this.geofence.geofence.polyData
            var polyArray = polyData.split('),')
            polyArray.forEach(function (item) {
              newPoly.push(item.replaceAll('(', '').replaceAll(')', '').split(','))
            })
          }
          old.poly_data = newPoly
          old.circle_data = []
          old.radius = null
        }
        return old
      }

      return {}
    },
    uuid() {
      let uuid = this.$route.params.id ? this.form.customerId : this.$route.params.uuid
      return uuid
    },
    filteredOptions() {
      let options = this.categoryOptions
      if (this.isHQ) {
        options = options.filter((item) => item !== 'Kantor Pusat')
      }
      return options
    },
    isGeofenceContactFormFlagActive() {
      return this.getFeatureFlagData('geofence_contact_form_disable').value
    },
    operationalTime() {
      // If operationalDay includes 0 (Semua/All), return empty object
      if (this.form.operationalDay && this.form.operationalDay.includes('0')) {
        return {}
      }

      const dayMapping = {
        1: 'monday',
        2: 'tuesday',
        3: 'wednesday',
        4: 'thursday',
        5: 'friday',
        6: 'saturday',
        7: 'sunday',
      }

      const result = {}

      if (this.form.operationalDay && this.form.operationalDay.length > 0) {
        // TODO: Uncomment when each operational day using each service start and service end
        // const timeSlot = {
        //   ...(this.form.serviceStart && {
        //     startTime: moment(this.form.serviceStart, 'HH:mm').format('HH:mm:ss'),
        //   }),
        //   ...(this.form.serviceEnd && {
        //     endTime: moment(this.form.serviceEnd, 'HH:mm').format('HH:mm:ss'),
        //   })
        // }
        this.form.operationalDay.forEach((dayValue) => {
          const dayName = dayMapping[dayValue]
          if (dayName) {
            // TODO: Uncomment when each operational day using each service start and service end
            // result[dayName] = Object.keys(timeSlot).length > 0 ? [timeSlot] : []
            result[dayName] = []
          }
        })
      }

      return result
    },
  },
  watch: {
    'form.province': {
      async handler(newValue, oldValue) {
        if (newValue === oldValue) return
        if (this.isInitSearchRegion) return
        await this.changeProvince(newValue)
      },
    },
    'form.city': {
      async handler(newValue, oldValue) {
        if (newValue === oldValue) return
        if (this.isInitSearchRegion) return
        await this.changeCity(newValue)
      },
    },
  },
  created() {
    for (let i = 0; i < this.tData.length; i++) {
      this.selectedModel.push(false)
    }
  },
  async mounted() {
    const self = this

    this.customer = {
      name: this.$route.query.customerName,
      uuid: this.$route.params.uuid,
    }

    await this.loadProvinceOptions()

    await this.$refs.MapAddress.$mapPromise.then((map) => {
      self.map = map
    })
    setTimeout(() => {
      var input = document.getElementById('search-address')

      const searchBox = new this.google.maps.places.SearchBox(input)

      // Bias the SearchBox results towards current map's viewport.
      this.map.addListener('bounds_changed', () => {
        searchBox.setBounds(this.map.getBounds())
      })

      // Listen for the event fired when the user selects a prediction and retrieve
      // more details for that place.
      searchBox.addListener('places_changed', () => {
        this.isEdit = false
        const places = searchBox.getPlaces()
        this.places = places
        if (places.length == 0) {
          return
        }

        if (this.map_radio === 'circle') {
          this.initMapCircle(places)
        } else if (this.map_radio === 'polygon') {
          this.initMapPoly(places)
        }
      })
    }, 200)
  },
  methods: {
    async searchProvinces(filter) {
      const response = await this.$apollo.query({
        query: GET_PROVINCES,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.provinces?.data || [],
        pagination: response?.data?.data?.provinces?.pagination || {},
      }
    },
    async searchCities(filter) {
      const response = await this.$apollo.query({
        query: GET_CITIES,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.cities?.data || [],
        pagination: response?.data?.data?.cities?.pagination || {},
      }
    },
    async searchDistricts(filter) {
      const response = await this.$apollo.query({
        query: GET_DISTRICTS,
        fetchPolicy: 'no-cache',
        variables: {
          filter,
        },
      })

      return {
        data: response?.data?.data?.districts?.data || [],
        pagination: response?.data?.data?.districts?.pagination || {},
      }
    },
    async loadProvinceOptions() {
      const { data } = await this.searchProvinces({
        pagination: {
          page: 1,
          show: 100,
        },
      })
      this.regionOptions.provinces = data || []
    },
    async loadCityOptions(provinceId) {
      if (!provinceId) {
        this.regionOptions.cities = []
        return
      }
      const { data } = await this.searchCities({
        pagination: {
          page: 1,
          show: 500,
        },
        provinceId,
      })
      this.regionOptions.cities = data || []
    },
    async loadDistrictOptions(provinceId, cityId) {
      if (!provinceId || !cityId) {
        this.regionOptions.districts = []
        return
      }
      const { data } = await this.searchDistricts({
        pagination: {
          page: 1,
          show: 1000,
        },
        provinceId,
        cityId,
      })
      this.regionOptions.districts = data || []
    },
    normalizeRegionName(value) {
      return (value || '').trim().toLowerCase()
    },
    findExactRegionByName(options, name) {
      const normalizedName = this.normalizeRegionName(name)
      if (!normalizedName) return null

      return options.find((item) => this.normalizeRegionName(item?.name) === normalizedName) || null
    },
    async searchInitialRegion() {
      try {
        this.isInitSearchRegion = true

        const geofenceProvince = this.geofence.geofence.province || null
        const geofenceCity = this.geofence.geofence.city || null
        const geofenceDistrict = this.geofence.geofence.district || null

        await this.loadProvinceOptions()

        const selectedProvince = this.findExactRegionByName(
          this.regionOptions.provinces,
          geofenceProvince
        )
        this.selectedRegion.province = selectedProvince
        this.form.province = selectedProvince ? selectedProvince.name : geofenceProvince

        if (!selectedProvince) {
          this.selectedRegion.city = null
          this.selectedRegion.district = null
          this.regionOptions.cities = []
          this.regionOptions.districts = []
          this.form.city = geofenceCity
          this.form.district = geofenceDistrict
          return
        }

        await this.loadCityOptions(selectedProvince.regionId)
        const selectedCity = this.findExactRegionByName(this.regionOptions.cities, geofenceCity)
        this.selectedRegion.city = selectedCity
        this.form.city = selectedCity ? selectedCity.name : geofenceCity

        if (!selectedCity) {
          this.selectedRegion.district = null
          this.regionOptions.districts = []
          this.form.district = geofenceDistrict
          return
        }

        await this.loadDistrictOptions(selectedProvince.regionId, selectedCity.regionId)
        const selectedDistrict = this.findExactRegionByName(
          this.regionOptions.districts,
          geofenceDistrict
        )
        this.selectedRegion.district = selectedDistrict
        this.form.district = selectedDistrict ? selectedDistrict.name : geofenceDistrict
      } finally {
        this.isInitSearchRegion = false
      }
    },
    async initEditPage() {
      this.isInitSearchRegion = true
      try {
        this.isEdit = true
        this.form.customerId = this.geofence.geofence.customerId
        this.form.customerName = this.geofence.geofence.customerName
        this.form.location_name = this.geofence.geofence.fenceName
        this.form.address = this.geofence.geofence.address
        this.form.address_detail = this.geofence.geofence.addressDetail
        this.form.province = this.geofence.geofence.province
        this.form.city = this.geofence.geofence.city
        this.form.district = this.geofence.geofence.district
        this.form.postal_code = this.geofence.geofence.postalCode
        this.form.sector = this.geofence.geofence.category
        this.form.contact_person = this.geofence.geofence.contactName
        this.form.phone_no = this.geofence.geofence.phoneNo
        this.form.is_billingAddr = this.geofence.geofence.isBillingAddr
        this.form.is_depot = this.geofence.geofence.isDepot
        this.form.serviceStart = this.geofence.geofence.serviceStart
        this.form.serviceEnd = this.geofence.geofence.serviceEnd
        this.form.serviceDuration = this.geofence.geofence.serviceDuration
        this.form.reference_id = this.geofence.geofence.thirdPartyId
        await this.searchInitialRegion()
      } finally {
        this.isInitSearchRegion = false
      }

      // Handle operationalTime to operationalDay conversion
      if (this.geofence.geofence.operationalTime) {
        const operationalTime = this.geofence.geofence.operationalTime

        // Check if operationalTime is empty object (means "Semua"/All days)
        if (Object.keys(operationalTime).length === 0) {
          this.form.operationalDay = ['0']
        } else {
          const dayMapping = {
            monday: '1',
            tuesday: '2',
            wednesday: '3',
            thursday: '4',
            friday: '5',
            saturday: '6',
            sunday: '7',
          }

          this.form.operationalDay = Object.keys(operationalTime).map((day) => dayMapping[day])
        }
      }

      this.map_radio = this.geofence.geofence.type == 'C' ? 'circle' : 'polygon'
      if (this.map_radio == 'circle') {
        var circData = this.geofence.geofence.circData.replace('<', '').replace('>', '')
        var circleArray = circData.split('),')
        this.form.radius = circleArray[1]
        this.form.latLang = circleArray[0] + ')'
        var latLang = circleArray[0].replace('(', '').split(',')

        this.form.circle_data = latLang

        this.map.panTo({
          lat: parseFloat(latLang[0]),
          lng: parseFloat(latLang[1]),
        })
        this.form.latitude = latLang[0]
        this.form.longitude = latLang[1]
        this.map.setZoom(17)

        this.initMapCircle()
      } else {
        var polyData = this.geofence.geofence.polyData
        this.form.latLang = polyData.slice(1, -1)
        this.form.radius = null
        var polyArray = polyData.split('),')
        var newPoly = []
        polyArray.forEach(function (item) {
          newPoly.push(item.replaceAll('(', '').replaceAll(')', '').split(','))
        })

        this.form.poly_data = newPoly
        this.initMapPoly()
      }
    },
    initMapCircle(places) {
      if (this.circle != null) {
        this.circle.setMap(null)
        this.circle = null
      }

      this.circle = new this.google.maps.Circle({
        strokeColor: '#0D4491',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1C74DA',
        fillOpacity: 0.35,
        map: this.map,
        radius: parseInt(this.form.radius),
        editable: true,
        draggable: true,
      })
      var circle = this.circle

      this.circle.setMap(null)
      this.circle.setMap(this.map)

      if (places === undefined) {
        this.circle.setCenter({
          lat: parseFloat(this.form.latitude),
          lng: parseFloat(this.form.longitude),
        })
      } else {
        this.circle.setCenter(places[0].geometry.location)
      }

      this.map.fitBounds(this.circle.getBounds())

      this.google.maps.event.addListener(circle, 'center_changed', () => {
        this.updateCircleCoordsState(circle)
      })

      this.google.maps.event.addListener(circle, 'radius_changed', () => {
        this.updateCircleCoordsState(circle)
      })
    },
    initMapPoly(places) {
      if (this.polygon != null) {
        this.polygon.setMap(null)
        this.polygon = null
      }

      var Coords = []
      if (places !== undefined) {
        Coords = [
          {
            lat: places[0].geometry.location.lat() - 1 / 1000,
            lng: places[0].geometry.location.lng() + 1 / 1000,
          },
          {
            lat: places[0].geometry.location.lat() - 1 / 1000,
            lng: places[0].geometry.location.lng() - 1 / 1000,
          },
          {
            lat: places[0].geometry.location.lat() + 1 / 1000,
            lng: places[0].geometry.location.lng() - 1 / 1000,
          },
          {
            lat: places[0].geometry.location.lat() + 1 / 1000,
            lng: places[0].geometry.location.lng() + 1 / 1000,
          },
        ]
      } else {
        this.form.poly_data.forEach(function (item) {
          Coords.push({
            lat: parseFloat(item[0]),
            lng: parseFloat(item[1]),
          })
        })
      }

      // Construct the polygon.
      this.polygon = new this.google.maps.Polygon({
        paths: Coords,
        strokeColor: '#0D4491',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1C74DA',
        fillOpacity: 0.35,
        editable: true,
        draggable: true,
      })
      this.polygon.setMap(null)
      this.polygon.setMap(this.map)

      const bounds = new this.google.maps.LatLngBounds()

      if (places !== undefined) {
        if (places[0].geometry.viewport) {
          bounds.union(places[0].geometry.viewport)
        } else {
          bounds.extend(places[0].geometry.location)
        }

        this.map.fitBounds(bounds)
      } else {
        this.map.panTo({
          lat: parseFloat(this.form.poly_data[0][0]),
          lng: parseFloat(this.form.poly_data[0][1]),
        })

        this.map.setZoom(16)
      }

      this.polygon.getPaths().forEach((path) => {
        this.google.maps.event.addListener(path, 'insert_at', () => {
          this.updatePolygonCoordsState(path)
        })

        this.google.maps.event.addListener(path, 'remove_at', () => {
          this.updatePolygonCoordsState(path)
        })

        this.google.maps.event.addListener(path, 'set_at', () => {
          this.updatePolygonCoordsState(path)
        })
      })
    },
    getCenterpoint(latlong) {
      const coords = latlong.map(([lat, lng]) => ({ lat, lng }))
      let bounds = new this.google.maps.LatLngBounds()
      coords.forEach((element) => {
        bounds.extend(element)
      })
      const center = bounds.getCenter()
      return { lat: center.lat(), long: center.lng() }
    },
    async getLocation() {
      if (this.map_radio === 'circle') {
        if (this.circle == null) return

        this.form.latitude = this.circle.center.lat()
        this.form.longitude = this.circle.center.lng()
        this.form.radius = this.circle.getRadius()

        this.form.circle_data = [this.form.latitude, this.form.longitude]
        this.form.latLang = '(' + this.form.latitude + ', ' + this.form.longitude + ')'
      } else if (this.map_radio === 'polygon') {
        if (this.polygon == null) return

        this.form.poly_data = []
        let latLang = []
        for (let i = 0; i < this.polygon.getPath().getLength(); i++) {
          let lat = parseFloat(this.polygon.getPath().getAt(i).lat()).toFixed(8)
          let lang = parseFloat(this.polygon.getPath().getAt(i).lng()).toFixed(8)

          this.form.poly_data.push([lat, lang])
          latLang.push('(' + lat + ', ' + lang + ')')
        }

        this.form.latLang = latLang.join(', ')
        const floatData = this.form.poly_data.map(([lat, lng]) => [
          parseFloat(lat),
          parseFloat(lng),
        ])
        const center = this.getCenterpoint(floatData)
        this.form.latitude = center.lat
        this.form.longitude = center.long
      }

      await this.getPlace(this.form.longitude, this.form.latitude)
    },
    async getPlace(lon, lat) {
      const useCache = this.isUsingCache()
      let data = null

      if (useCache) {
        const reverse = await getGeolocation({ lat, lon })
        const address = getAddress(reverse, lat, lon)
        if (address) data = { ...address, address: address.name }
      } else {
        const { display_name } = await GetAddressData(lat, lon)
        data = {
          address: display_name,
        }
      }

      const { data: regionData } = await this.$apollo.query({
        query: GET_REGION_BY_LAT_LNG,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            latitude: lat,
            longitude: lon,
          },
        },
      })

      const provinceData = regionData?.data?.regionByLatLng?.province
      const cityData = regionData?.data?.regionByLatLng?.city
      const districtData = regionData?.data?.regionByLatLng?.district

      data = {
        ...data,
        province: provinceData?.name || null,
        city: cityData?.name || null,
        district: districtData?.name || null,
      }

      this.form.address = data?.address || null
      this.form.province = data?.province || null
      this.form.city = data?.city || null
      this.form.district = data?.district || null

      this.selectedRegion.province = provinceData || null
      this.selectedRegion.city = cityData || null
      this.selectedRegion.district = districtData || null

      await this.$nextTick()

      await this.loadCityOptions(provinceData?.regionId)
      await this.loadDistrictOptions(provinceData?.regionId, cityData?.regionId)
    },
    changeGeoType(item) {
      if (this.circle != null) {
        this.circle.setMap(null)
        this.circle = null
        this.circle_error = false
        this.form.circle_data = []
        this.form.latLang = ''
      } else if (this.polygon != null) {
        this.polygon.setMap(null)
        this.polygon = null
        this.poly_error = false
        this.form.poly_data = []
        this.form.latLang = ''
      }

      if (item == 'polygon') {
        this.form.radius = null
      } else if (item == 'circle') {
        this.form.radius = 100
      }
      if (this.places && this.places.length > 0) {
        if (item === 'circle') {
          this.initMapCircle(this.places)

          this.form.latitude = this.circle.center.lat()
          this.form.longitude = this.circle.center.lng()
          this.form.radius = this.circle.getRadius()

          this.form.circle_data = [this.form.latitude, this.form.longitude]
          this.form.latLang = '(' + this.form.latitude + ', ' + this.form.longitude + ')'
        } else if (item === 'polygon') {
          this.initMapPoly(this.places)

          this.form.poly_data = []
          var latLang = []
          for (var i = 0; i < this.polygon.getPath().getLength(); i++) {
            var lat = parseFloat(this.polygon.getPath().getAt(i).lat()).toFixed(8)
            var lang = parseFloat(this.polygon.getPath().getAt(i).lng()).toFixed(8)

            this.form.poly_data.push([lat, lang])
            latLang.push('(' + lat + ', ' + lang + ')')
          }

          this.form.latLang = latLang.join(', ')
          this.form.radius = null
          const bounds = new this.google.maps.LatLngBounds()
          if (this.places[0].geometry.viewport) {
            bounds.union(this.places[0].geometry.viewport)
          } else {
            bounds.extend(this.places[0].geometry.location)
          }
          this.map.fitBounds(bounds)
        }
      }
    },
    async changeProvince(province) {
      const selectedProvince = this.findExactRegionByName(this.regionOptions.provinces, province)
      this.selectedRegion.province = selectedProvince || null
      this.selectedRegion.city = null
      this.selectedRegion.district = null
      this.form.city = null
      this.form.district = null
      this.regionOptions.districts = []

      await this.loadCityOptions(selectedProvince?.regionId)
    },
    async changeCity(city) {
      const selectedCity = this.findExactRegionByName(this.regionOptions.cities, city)
      this.selectedRegion.city = selectedCity || null
      this.selectedRegion.district = null
      this.form.district = null

      await this.loadDistrictOptions(this.selectedRegion.province?.regionId, selectedCity?.regionId)
    },
    setLocation() {
      this.isInitSearchRegion = true
      setTimeout(async () => {
        try {
          await this.getLocation()
        } finally {
          this.isInitSearchRegion = false
        }
      }, 1200)
    },
    setRadius() {
      setTimeout(() => {
        if (this.circle != null && this.form.radius) {
          this.circle.setRadius(parseInt(this.form.radius))
          this.map.fitBounds(this.circle.getBounds())
        }
      }, 200)
    },
    deleteVector() {
      if (this.circle != null) {
        this.circle.setMap(null)
        this.circle = null
        this.form.radius = 100
      } else if (this.polygon != null) {
        this.polygon.setMap(null)
        this.polygon = null
        this.form.radius = null
      }

      this.form.address = null
      this.form.province = null
      this.form.city = null
      this.form.district = null
      this.form.postal_code = null
      this.form.latitude = null
      this.form.longitude = null
      this.form.latLang = null
      this.form.circle_data = null
      this.form.poly_data = null
      this.regionOptions.cities = []
      this.regionOptions.districts = []
      this.selectedRegion.province = null
      this.selectedRegion.city = null
      this.selectedRegion.district = null
      this.places = null
    },
    submitForm() {
      // stop here if form is invalid
      this.$v.$touch()
    },
    toggleAll(checked) {
      this.selectedModel = []
      this.selected = []
      if (checked) {
        for (let i = 0; i < this.tData.length; i++) {
          this.selected.push(i)
          this.selectedModel.push(true)
        }
      } else {
        for (let i = 0; i < this.tData.length; i++) {
          this.selectedModel.push(false)
        }
        this.selected = []
      }
    },
    checkTable(event, data) {
      if (event) {
        this.selected.push(data.index)
      } else {
        var myIndex = this.selected.indexOf(data.index)
        if (myIndex !== -1) {
          this.selected.splice(myIndex, 1)
        }
      }
    },
    addDocumentPermit() {
      this.tData.push({
        type: null,
        number: null,
        expired: null,
        status: null,
      })
    },
    checkStatus(index) {
      const today = new Date()
      const zeroPad = (num, places) => String(num).padStart(places, '0')
      const date =
        today.getFullYear() + '-' + zeroPad(today.getMonth() + 1, 2) + '-' + today.getDate()
      if (date >= this.tData[index].expired) {
        this.tData[index].status = 'expired'
      } else {
        var range = this.getDatesInRange(date, this.tData[index].expired).length
        if (range <= 30) {
          this.tData[index].status = 'near'
        } else {
          this.tData[index].status = 'active'
        }
      }
    },
    getDatesInRange(startDate, endDate) {
      startDate = new Date(startDate)
      endDate = new Date(endDate)
      const date = new Date(startDate.getTime())

      const dates = []

      while (date <= endDate) {
        dates.push(new Date(date))
        date.setDate(date.getDate() + 1)
      }

      return dates
    },
    onChangeNumber() {
      let text = this.form.phone_no
      const conditions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '(', ')', '-']
      for (let i = 0; i < text.length; i++) {
        var state = false
        for (let j = 0; j < conditions.length; j++) {
          if (conditions[j] == text[i]) {
            state = true
            break
          }
        }
        if (state == false) {
          this.form.phone_no = null
          break
        }
      }
    },
    checkEmpty() {
      var isEmpty = true
      var forms = this.form
      var excepts = ['poly_data', 'circle_data', 'is_garage', 'radius']
      Object.keys(this.form).forEach(function (key) {
        if (forms[key] != null && forms[key] != '') {
          if (typeof forms[key] !== 'object') {
            if (!excepts.includes(key)) {
              isEmpty = false
            }
          } else {
            if (!excepts.includes(key)) {
              Object.keys(forms[key]).forEach(function (subKey) {
                if (forms[key][subKey] != null && forms[key][subKey] != '') {
                  isEmpty = false
                }
              })
            }
          }
        }
      })

      return isEmpty
    },
    checkChanged() {
      var isChanged = false
      var forms = this.form
      var formOld = this.oldData
      var excepts = ['latLang', 'longitude', 'latitude', 'customerId', 'customerName']
      var formField = {
        location_name: 'fenceName',
        address: 'address',
        address_detail: 'addressDetail',
        province: 'province',
        city: 'city',
        district: 'district',
        postal_code: 'postalCode',
        sector: 'category',
        contact_person: 'contactName',
        phone_no: 'phoneNo',
        is_garage: 'isGarage',
        is_service: 'isServiceLoc',
        is_billingAddr: 'isBillingAddr',
        is_depot: 'isDepot',
        serviceStart: 'serviceStart',
        serviceEnd: 'serviceEnd',
        serviceDuration: 'serviceDuration',
        radius: 'radius',
        circle_data: 'circle_data',
        poly_data: 'poly_data',
        reference_id: 'thirdPartyId',
      }
      Object.keys(this.form).forEach(function (key) {
        if (!excepts.includes(key)) {
          if (forms[key] != formOld[formField[key]]) {
            if (key == 'circle_data') {
              if (JSON.stringify(forms[key]) != JSON.stringify(formOld[formField[key]])) {
                isChanged = true
              }
            } else if (key == 'poly_data') {
              if (JSON.stringify(forms[key]) != JSON.stringify(formOld[formField[key]])) {
                isChanged = true
              }
            } else {
              isChanged = true
            }
          }
        }
      })

      return isChanged
    },
    toCancel() {
      var isEmpty = this.checkEmpty()
      if (this.$route.params.id) {
        isEmpty = !this.checkChanged()
      }
      if (isEmpty) {
        this.$router.push({
          name: 'Master Customer Update',
          params: { id: this.$route.params.uuid },
        })
      } else {
        Swal.fire({
          title: 'Batalkan',
          text: 'Anda yakin akan membatalkan',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: 'Master Customer Update',
              params: { id: this.uuid },
            })
          }
        })
      }
    },
    updatePolygonCoordsState(poly) {
      this.form.poly_data = []

      var latLang = []
      for (var i = 0; i < poly.getLength(); i++) {
        var koma = ''
        if (poly.getLength() - 1 != i) {
          koma = ','
        }

        var lat = parseFloat(poly.getAt(i).lat()).toFixed(8)
        var lang = parseFloat(poly.getAt(i).lng()).toFixed(8)
        this.form.latitude += lat + koma
        this.form.longitude += lang + koma

        this.form.poly_data.push([lat, lang])
        latLang.push('(' + lat + ', ' + lang + ')')
      }

      this.form.latLang = latLang.join(', ')
    },
    updateCircleCoordsState(circle) {
      this.form.latitude = circle.center.lat()
      this.form.longitude = circle.center.lng()
      this.form.radius = circle.getRadius()

      this.form.circle_data = [this.form.latitude, this.form.longitude]
      this.form.latLang = '(' + this.form.latitude + ', ' + this.form.longitude + ')'
    },
    checkGarage() {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }
      if (this.$refs.formRef.hasErrors) {
        this.$mcToast.error(this.$t('master.form.address.invalidFormat'))
        return
      }
      if (this.$route.params.id === undefined) return this.toSave()
      var isGarage = this.form.is_garage
      var oldGarage = this.oldData.isGarage
      if (oldGarage === true) {
        if (isGarage === false) {
          this.$bvModal.show('modal-change-data')
          return
        }
      }
      this.toSave()
    },
    resetForm() {
      this.invalid = false
      this.duplicateLocation = false
      this.duplicateReferenceId = false
      this.formErrors = {}
    },
    getErrorMessageToast(message, defaultErrMsg) {
      let errMsg = defaultErrMsg

      if (message == 'Error: "Geofence name already exists"') {
        this.invalid = true
        this.duplicateLocation = true
      } else if (message == 'Error: "thirdPartyId already exists"') {
        this.duplicateReferenceId = true
        errMsg = `${this.$t('master.form.address.referenceId')} ${this.$t(
          'global.alert.text.alreadyExist'
        )}`
        this.$set(this.formErrors, 'reference_id', ' ')
      } else if (message == 'Error: "Service duration must be between 00:01:00 and 23:59:59"') {
        errMsg = `${this.$t('master.form.address.serviceDurationExceedLimit')}`
        this.$set(this.formErrors, 'service_duration', ' ')
      } else if (
        message ==
        'Error: "thirdPartyId can only contain letters, numbers, and the characters . _ -"'
      ) {
        errMsg = `${this.$t('master.form.address.referenceIdInvalidChar')}`
        this.$set(this.formErrors, 'reference_id', `${this.$t('setting.wrongFormat')}`)
      }

      return errMsg
    },
    toSave() {
      this.resetForm()
      var form = this.convertNewData()
      if (this.id !== undefined && this.id != 0) {
        var type = this.oldData.type == 'C' ? 'circle' : 'polygon'
        var oldData = {
          circData: this.oldData.circData,
          polyData: this.oldData.polyData,
          fenceName: this.oldData.fenceName,
          type: type,
          address: this.oldData.address,
          addressDetail: this.oldData.addressDetail,
          province: this.oldData.province,
          city: this.oldData.city,
          district: this.oldData.district,
          postalCode: this.oldData.postalCode,
          category: this.oldData.category,
          contactName: this.oldData.contactName,
          phoneNo: this.oldData.phoneNo,
          serviceStart: this.oldData.serviceStart,
          serviceEnd: this.oldData.serviceEnd,
          serviceDuration: this.oldData.serviceDuration,
          thirdPartyId: this.oldData.thirdPartyId,
        }

        this.$apollo
          .mutate({
            mutation: UPDATE_ADDRESS,
            variables: {
              input: {
                geofenceId: parseInt(this.id),
                oldData: oldData,
                newData: form,
              },
            },
          })
          .then((response) => {
            if (response.data.updateGeofence.isSuccessful) {
              this.$apollo.queries.geofence.refetch()
              this.$mcToast.success(this.$t('global.alert.text.addressSaved'))
              this.$bvModal.hide('modal-change-data')

              setTimeout(() => {
                this.$router.push({
                  name: 'Master Customer Update',
                  params: { id: this.uuid },
                })
              }, 1000)
            } else {
              const errMsg = this.getErrorMessageToast(
                response.data.updateGeofence.message,
                response.data.updateGeofence.message
              )
              return this.$mcToast.error(errMsg)
            }
          })
      } else {
        this.$apollo
          .mutate({
            mutation: CREATE_ADDRESS,
            variables: {
              input: form,
            },
          })
          .then((response) => {
            if (response.data.createGeofence.isSuccessful) {
              this.$apollo.queries.geofence.refetch()
              this.$mcToast.success(this.$t('global.alert.text.addressSaved'))
              this.$bvModal.hide('modal-change-data')

              setTimeout(() => {
                this.$router.push({
                  name: 'Master Customer Update',
                  params: { id: this.uuid },
                })
              }, 1000)
            } else {
              const errMsg = this.getErrorMessageToast(
                response.data.createGeofence.message,
                response.data.createGeofence.message
              )
              return this.$mcToast.error(errMsg)
            }
          })
      }
    },
    convertNewData() {
      var latLangData = {}
      var type = null
      var circleData = '<' + this.form.latLang + ',' + this.form.radius + '>'
      var polyData = this.form.latLang

      if (this.map_radio == 'circle') {
        latLangData = {
          circData: circleData,
          polyData: null,
        }
        type = 'circle'
      } else if (this.map_radio == 'polygon') {
        latLangData = {
          polyData: polyData,
          circData: null,
        }
        type = 'polygon'
      }

      var form = {
        ...latLangData,
        fenceName: this.form.location_name,
        type: type,
        address: this.form.address,
        addressDetail: this.form.address_detail,
        province: this.form.province,
        city: this.form.city,
        district: this.form.district,
        postalCode: this.form.postal_code,
        category: this.form.sector,
        ...(!this.isGeofenceContactFormFlagActive && {
          contactName: this.form.contact_person,
          phoneNo: this.form.phone_no,
        }),
        serviceStart: this.form.serviceStart
          ? moment(this.form.serviceStart, 'HH:mm').format('HH:mm:ss')
          : null,
        serviceEnd: this.form.serviceEnd
          ? moment(this.form.serviceEnd, 'HH:mm').format('HH:mm:ss')
          : null,
        serviceDuration: this.form.serviceDuration || null,
        operationalTime: this.operationalTime,
        isDepot: this.form.is_depot,
        isBillingAddr: this.form.is_billingAddr,
        customerName: this.isEdit ? this.form.customerName : this.customer.name,
        customerId: this.isEdit ? this.form.customerId : this.customer.uuid,
        thirdPartyId: this.form.reference_id,
      }

      return form
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            variant="secondary"
            class="mx-2"
            icon="icon-fill_close"
            :text="$t('global.cancel')"
            @click="toCancel"
          />
          <McButton
            variant="primary"
            icon="icon-outline_save"
            :text="$t('global.save')"
            @click="checkGarage"
          />
        </div>
      </div>
    </div>

    <FormulateForm
      ref="formRef"
      v-model="form"
      :errors="formErrors"
      class="needs-validation mc-form mc-form--address"
      @submit.prevent="submitForm"
    >
      <b-row>
        <b-col sm="12" md="7">
          <b-card>
            <b-row class="mc-form--address-search mb-2">
              <b-col md="10">
                <b-form-input
                  id="search-address"
                  v-model="searchLocation"
                  :placeholder="$t('master.form.address.searchLocation')"
                  trim
                  autocomplete="off"
                  @change="setLocation"
                />
              </b-col>
              <b-col md="2">
                <McButton
                  class="mc-btn--block"
                  variant="primary"
                  :text="$t('global.search')"
                  @click="getLocation"
                />
              </b-col>
              <!-- TODO: disabled button on map background color still same as not disabled button -->
              <b-col md="12">
                <div class="mc-map-address-icon">
                  <a id="eraser" name="delete-form" value="eraser" @click="deleteVector">
                    <label for="eraser">
                      <i class="fas fa-eraser"></i>
                    </label>
                  </a>

                  <span>
                    <input
                      id="polygon"
                      v-model="map_radio"
                      type="radio"
                      name="map-radio"
                      value="polygon"
                      :disabled="isEdit"
                      @input="changeGeoType('polygon')"
                    />
                    <label for="polygon">
                      <i class="fas fa-draw-polygon"></i>
                    </label>
                  </span>

                  <span>
                    <input
                      id="circle"
                      v-model="map_radio"
                      type="radio"
                      name="map-radio"
                      value="circle"
                      :disabled="isEdit"
                      @input="changeGeoType('circle')"
                    />
                    <label for="circle">
                      <i class="fas fa-circle"></i>
                    </label>
                  </span>
                </div>
                <GmapMap
                  id="map"
                  ref="MapAddress"
                  :center="$store.state.map.center"
                  :zoom="parseFloat($store.state.map.zoom)"
                  class="mc-map-address mt-2"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col sm="12" md="5">
          <b-card>
            <b-row>
              <h4 class="card-title mb-4">
                {{ $t('setting.list.company.form.address') }}
              </h4>
              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="customer_name_label"
                    :label="$t('master.form.address.name')"
                    label-for="customer_name"
                    label-class="required"
                  >
                    <b-form-input
                      id="location_name"
                      v-model="form.location_name"
                      :placeholder="$t('master.form.address.name')"
                      type="text"
                      :class="{
                        'is-invalid': $v.form.location_name.$error || invalid,
                      }"
                      @input="resetForm"
                    />
                    <div v-if="$v.form.location_name.$error || invalid" class="invalid-feedback">
                      <span v-if="duplicateLocation">{{
                        $t('master.form.address.duplicateLocation')
                      }}</span>
                      <span v-if="!$v.form.location_name.required">
                        {{ $t('setting.list.company.form.location') }}
                        {{ $t('global.validation.required') }}
                      </span>
                      <span v-if="!$v.form.location_name.maxLength">
                        {{ $t('setting.list.company.formAlert.locationLimit') }}</span
                      >
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="sector_label"
                    :label="$t('master.form.address.category')"
                    label-for="sector"
                    label-class="required"
                  >
                    <multiselect
                      v-model="form.sector"
                      :placeholder="`${$t('global.form.select')} ${$t(
                        'master.form.address.category'
                      )}`"
                      :class="{
                        'is-invalid': $v.form.sector.$error,
                      }"
                      :options="filteredOptions"
                    />
                    <div v-if="$v.form.sector.$error" class="invalid-feedback">
                      <span v-if="!$v.form.sector.required">
                        {{ $t('master.address.addressCategory') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="6" sm="12">
                <div class="mb-3">
                  <FormulateInput
                    id="reference_id"
                    name="reference_id"
                    :placeholder="$t('master.form.address.referenceId')"
                    type="text"
                    :validation="[
                      ['bail'],
                      ['optional'],
                      ['matches', /\S/],
                      ['between', 0, 64, 'length'],
                      ['isDuplicate', duplicateReferenceId],
                    ]"
                    :validation-messages="{
                      matches: $t('master.form.address.referenceIdNoSpace'),
                      between: $t('master.form.address.referenceIdLimit'),
                      isDuplicate: $t('master.form.address.referenceIdDuplicate'),
                    }"
                    validation-behavior="live"
                    error-behavior="live"
                    @input="resetForm"
                  >
                    <template #label>
                      <div class="d-flex justify-content-between align-items-center">
                        <label>
                          {{ $t('master.form.address.referenceId') }}
                        </label>
                      </div>
                    </template>
                  </FormulateInput>
                </div>
              </b-col>

              <b-col md="12" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="address_label"
                    :label="$t('master.form.address.fullAddress')"
                    label-for="address"
                    label-class="required"
                  >
                    <b-form-textarea
                      id="address"
                      v-model="form.address"
                      :placeholder="$t('master.form.address.fullAddress')"
                      :disabled="isInitSearchRegion"
                      rows="3"
                      :class="{
                        'is-invalid': $v.form.address.$error,
                      }"
                      max-rows="6"
                    />
                    <div v-if="$v.form.address.$error" class="invalid-feedback">
                      <span v-if="!$v.form.address.required">
                        {{ $t('setting.list.company.form.fullAddress') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <!-- Province -->
              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="province_label"
                    :label="$t('master.form.address.province')"
                    label-for="province"
                    label-class="required"
                  >
                    <multiselect
                      v-model="form.province"
                      :placeholder="`${$t('global.form.select')} ${$t(
                        'master.form.address.province'
                      )}`"
                      :disabled="isInitSearchRegion"
                      :options="provinces"
                      :class="{
                        'is-invalid': $v.form.province.$error,
                      }"
                    />
                    <div v-if="$v.form.province.$error" class="invalid-feedback">
                      <span v-if="!$v.form.province.required">
                        {{ $t('master.form.address.province') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <!-- City -->
              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="city_label"
                    :label="$t('master.form.address.city')"
                    label-for="city"
                    label-class="required"
                  >
                    <multiselect
                      v-model="form.city"
                      :placeholder="`${$t('global.form.select')} ${$t('master.form.address.city')}`"
                      :disabled="isInitSearchRegion"
                      :options="cities"
                      :class="{
                        'is-invalid': $v.form.city.$error,
                      }"
                    />
                    <div v-if="$v.form.city.$error" class="invalid-feedback">
                      <span v-if="!$v.form.city.required">
                        {{ $t('master.form.address.city') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>
              <!-- District -->
              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="district_label"
                    :label="$t('master.form.address.district')"
                    label-for="district"
                  >
                    <multiselect
                      v-model="form.district"
                      :placeholder="`${$t('global.form.select')} ${$t(
                        'master.form.address.district'
                      )}`"
                      :disabled="isInitSearchRegion"
                      :options="districts"
                    />
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    v-if="map_radio == 'circle'"
                    id="circle_data_label"
                    :label="$t('master.form.address.latAndLong')"
                    label-for="circle_data"
                    label-class="required"
                  >
                    <b-form-input
                      id="circle_data"
                      v-model="form.latLang"
                      :placeholder="$t('master.form.address.latAndLong')"
                      :disabled="isInitSearchRegion"
                      trim
                      :class="{
                        'is-invalid': $v.form.latLang.$error,
                      }"
                    />
                    <div v-if="$v.form.latLang.$error" class="invalid-feedback">
                      <span v-if="$v.form.latLang.$error">
                        {{ $t('setting.list.company.form.longitude') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>

                  <b-form-group
                    v-if="map_radio == 'polygon'"
                    id="poly_data_label"
                    :label="$t('master.form.address.latAndLong')"
                    label-for="poly_data"
                    label-class="required"
                  >
                    <b-form-input
                      id="poly_data"
                      v-model="form.latLang"
                      :placeholder="$t('master.form.address.latAndLong')"
                      :disabled="isInitSearchRegion"
                      trim
                      :class="{
                        'is-invalid': $v.form.latLang.$error,
                      }"
                    />
                    <div v-if="$v.form.latLang.$error" class="invalid-feedback">
                      <span v-if="$v.form.latLang.$error">
                        {{ $t('setting.list.company.form.longitude') }}
                        {{ $t('global.validation.required') }}
                      </span>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="8" sm="12">
                <div class="mb-3">
                  <b-form-group id="radius_label" label="Radius (m)" label-for="radius">
                    <b-form-input
                      id="radius"
                      v-model="form.radius"
                      placeholder="Radius"
                      type="text"
                      :disabled="map_radio == 'polygon'"
                    />
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="4" sm="12">
                <div class="row mt-4">
                  <span class="mc-form--address__geo">
                    {{ $t('setting.list.company.form.geofence') }}</span
                  >
                  <strong v-if="map_radio == 'circle'" class="mc-form--address__geo">
                    {{ $t('setting.list.company.form.circle') }}</strong
                  >
                  <strong v-if="map_radio == 'polygon'">
                    {{ $t('setting.list.company.form.polygon') }}</strong
                  >
                </div>
              </b-col>

              <b-col v-if="hasAccessAll(['tms:read'])" md="12" sm="12">
                <div class="mb-3">
                  <FormulateInput
                    v-model="form.operationalDay"
                    type="choice-chips"
                    class="p-0"
                    :label="$t('master.form.address.operationalDay')"
                    :options="operationalDayOptions"
                    :multiple="true"
                    :all-value="'0'"
                  />
                </div>
              </b-col>

              <b-col md="12" sm="12">
                <div class="mb-3 justify-content-center">
                  <b-form-group
                    id="time_label"
                    :label="$t('master.form.customer.operationalTime')"
                    label-for="time"
                  >
                    <div class="row">
                      <div class="col-lg-6">
                        <date-picker
                          v-model="form.serviceStart"
                          class="mc-start-time"
                          format="HH:mm"
                          value-type="format"
                          type="time"
                          placeholder="HH:mm"
                        />
                      </div>
                      <div class="col-lg-6">
                        <date-picker
                          v-model="form.serviceEnd"
                          format="HH:mm"
                          value-type="format"
                          type="time"
                          placeholder="HH:mm"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="12" sm="12">
                <div class="mb-3">
                  <FormulateInput
                    v-model="form.serviceDuration"
                    name="service_duration"
                    class="__duration-input"
                    :label="$t('master.form.address.serviceDuration')"
                    ignored
                    type="time-duration"
                    :placeholder="$t('master.form.address.serviceDurationPlaceholder')"
                    :optionItems="optionItems"
                  />
                </div>
              </b-col>

              <b-col md="12" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="address_label"
                    :label="$t('master.form.address.detail')"
                    label-for="address"
                  >
                    <b-form-textarea
                      id="address"
                      v-model="form.address_detail"
                      :placeholder="$t('master.form.address.exDetail')"
                      rows="3"
                      max-rows="6"
                    />
                  </b-form-group>
                </div>
              </b-col>

              <h4 class="card-title mb-4 mt-2">
                {{ $t('setting.list.company.form.contact') }}
              </h4>

              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="contact_person_label"
                    :label="$t('master.address.contactName')"
                    label-for="contact_person"
                  >
                    <b-form-input
                      id="contact_person"
                      v-model="form.contact_person"
                      :placeholder="$t('master.address.contactName')"
                      :class="{
                        'is-invalid': $v.form.contact_person.$error,
                      }"
                      :disabled="isGeofenceContactFormFlagActive"
                    />
                    <div v-if="$v.form.contact_person.$error" class="invalid-feedback">
                      <span v-if="!$v.form.contact_person.maxLength">
                        {{ $t('setting.list.company.formAlert.contactLimit') }}</span
                      >
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="6" sm="12">
                <div class="mb-3">
                  <b-form-group
                    id="radius_label"
                    :label="$t('master.form.employee.phoneNumber')"
                    label-for="radius"
                  >
                    <b-form-input
                      id="radius"
                      v-model="form.phone_no"
                      :placeholder="$t('master.form.employee.phoneNumber')"
                      :class="{
                        'is-invalid': $v.form.phone_no.$error,
                      }"
                      :disabled="isGeofenceContactFormFlagActive"
                      @keypress="isPhoneNumber($event)"
                      @paste="isPastePhoneNumber($event)"
                      @change="onChangeNumber()"
                    />
                    <div v-if="$v.form.phone_no.$error" class="invalid-feedback">
                      <span v-if="!$v.form.phone_no.maxLength">
                        {{ $t('setting.list.company.form.phoneLimit') }}</span
                      >
                    </div>
                  </b-form-group>
                </div>
              </b-col>

              <h4 class="card-title mb-4 mt-2">
                {{ $t('global.activity') }}
              </h4>

              <b-col md="12" sm="12" class="mb-4">
                <div class="p-2 form-control">
                  <div class="d-flex">
                    <b-form-checkbox
                      v-model="form.is_depot"
                      :value="true"
                      :unchecked-value="false"
                      class="mb-1 mt-1"
                      checked
                      plain
                    >
                      {{ $t('setting.list.company.form.pickUpAndDeliver') }}
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>

              <b-col md="12" sm="12">
                <div class="p-2 form-control">
                  <div class="d-flex">
                    <b-form-checkbox
                      v-model="form.is_billingAddr"
                      :value="true"
                      :unchecked-value="false"
                      class="mb-1 mt-1"
                      checked
                      plain
                    >
                      {{ $t('setting.list.company.form.invoice') }}
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </FormulateForm>

    <!-- Modal for Update Confirmation -->
    <b-modal
      id="modal-change-data"
      class="mc-modal"
      title="Hapus"
      size="md"
      centered
      scrollable
      @ok="toSave"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>
          {{ $t('master.address.addressAlreadyUse') }}
          <strong> {{ $t('setting.list.company.form.garage') }}</strong>
          {{ $t('global.byOtherFleet') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton variant="secondary" class="me-2" :text="$t('global.no')" @click="cancel()" />
            <McButton variant="primary" :text="$t('global.yes')" @click="toSave" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
